<template>
  <div
    class="title"
    :style="{ 'color': color }"
    v-html="content.toUpperCase()"
  >
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    content: String,
    color: String,
  },
  filters: {
    uppercase: value => value.toUpperCase(),
  },
};
</script>

<style scoped lang="scss">
  .title {
    position: relative;

    width: 100%;
    padding: 25px;

    font-weight: bold;
    font-size: 1.6em;

    @media (min-width: 992px) { padding: 25px 150px; font-size: 2.2em }
    @media (min-width: 1200px) {
      $width: 1200px;

      padding: 50px 25px;
      font-size: 3em;
      width: $width;
      left: calc(50% - calc(#{$width} / 2));
    }
  }
</style>
